import { useReveal } from "@/lib/useReveal";

const IMG_JOINERY =
  "/img/factory.webp";
const IMG_DETAIL =
  "/img/cnc.webp";

export const Workshop = () => {
  const ref = useReveal();
  return (
    <section
      id="workshop"
      ref={ref}
      data-testid="workshop-section"
      className="relative py-24 lg:py-32 bg-[#F5F5F4]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 items-start">
          <div className="col-span-12 lg:col-span-5 reveal lg:sticky lg:top-28">
            <div className="overline">03 — Workshop</div>
            <h2
              data-testid="workshop-heading"
              className="mt-5 font-display text-3xl sm:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]"
            >
              A 12,000 ft² workshop on our doorstep.
            </h2>
            <p className="mt-6 text-black/65 leading-relaxed max-w-md">
              Our facility houses bespoke joinery, solid surface manufacture,
              metalwork and a full spray paint &amp; finishes department under
              one roof — run by tradespeople who have spent their careers on
              the tools. Fabrication moves in parallel with site, compressing
              programmes and keeping quality control in hands we know.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-px bg-black/10">
              <Cell k="Workshop floor" v="12,000 ft²" testid="ws-stat-floor" />
              <Cell k="Disciplines" v="Joinery · Solid Surface · Metal · Spray Finishes" testid="ws-stat-disc" />
              <Cell k="Where" v="Scotland, UK" testid="ws-stat-loc" />
              <Cell k="Delivery" v="UK-wide" testid="ws-stat-del" />
            </div>
          </div>

          <div className="col-span-12 lg:col-span-7 reveal">
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-12">
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={IMG_JOINERY}
                    alt="Workshop — manufactured joinery"
                    className="w-full h-full object-cover hover:scale-[1.02] transition-transform duration-700"
                  />
                </div>
              </div>
              <div className="col-span-7">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={IMG_DETAIL}
                    alt="Material detail"
                    className="w-full h-full object-cover hover:scale-[1.02] transition-transform duration-700"
                  />
                </div>
              </div>
              <div className="col-span-5 bg-[#0A0A0A] text-white p-6 lg:p-8 flex flex-col justify-between">
                <div className="overline text-white/60">In-house fabrication</div>
                <div className="font-display text-2xl lg:text-3xl leading-tight">
                  Cut, welded, finished — under one roof.
                </div>
                <div className="text-xs tracking-[0.2em] uppercase text-white/55">
                  Anderston Workshop
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Cell = ({ k, v, testid }) => (
  <div data-testid={testid} className="bg-[#F5F5F4] p-5">
    <div className="overline">{k}</div>
    <div className="font-display text-lg mt-2 leading-snug">{v}</div>
  </div>
);

export default Workshop;
